
const constant = {
    websiteName:"RRRPay",
    baseUrl:"https://rockbhai.com/",
    whatsAppNumber:"+918918067955",
    instagramUrl:"https://www.instagram.com/rrrplay/",
    telegramUrl:"https://api.whatsapp.com/send/?phone=8918067955&text&type=phone_number&app_absent=0",
    youTubeUrl:"https://www.youtube.com/channel/UCcaunrHXS3IK8UEhQv34Q",
    apkUrl:"https://rrr-web.sgp1.cdn.digitaloceanspaces.com/android/RRRPlayV1.apk",
    landingPageLogoSize:"90px",
    logoPath:"logo.png",
    logoPath1:"logopath.png",
    minDepositCoins:100,
    minWithdrawalCoins:500,
    howToPayBankVid:"https://baazi-cdn.sgp1.cdn.digitaloceanspaces.com/howtoplay/UpiToBankAccountFairBaazi.mp4",
    numberOfIdsOnHome:15,
    maxHoursToShowPaymentVideo: 5,

    transactionType: {
        depositWallet: 'DepositWalletRequest',
        withdrawWallet: 'WithdrawWalletRequest',
        depositId: 'DepositIdRequest',
        withdrawId: 'WithdrawIdRequest',
        createIdRequest: 'CreateIdRequest',
        changeIdPasswordRequest: 'ChangeIdPasswordRequest',
        closeIdRequest:'CloseIdRequest',
    },
    transactionFor: {
        idDeposit: 'idDeposit',
        walletDeposit: 'walletDeposit',
        createIdDeposit: 'createIdDeposit',
        changePasswordRequest: 'changePasswordRequest'
    },
    accountType: {
        savings: 'savings',
        current: 'current'
    },
    transactionStatus: {
        success: 'success',
        scanning: 'scanning',
        failure: 'failure',
        pending: 'pending',
        created: 'created',
        error:'error',
        cancelled:'cancelled',
        approved:'approved',
        rejected:'rejected',
    }
}

export default constant;